import { PropsWithChildren, type JSX } from 'react';
import { compose } from './function';

export const stack =
  (...components: any[]) =>
  ({ children, ...props }: PropsWithChildren<any>): JSX.Element => {
    const fns = components.map(Component => (kids: any) => (
      <Component {...props}>{kids}</Component>
    ));
    return compose(...fns)(children);
  };
